/**
 * UserDashboardContainer
 * --
 */
import React from 'react';
import UserDashboardPresenter from './UserDashboardPresenter';

const UserDashboardContainer = () => {
  /* ===== ROUTE ===== */
  /* ===== PROPS ===== */
  /* ===== STATE ===== */
  /* ===== VARIABLE ===== */
  /* ===== FUNCTION ===== */
  /* ===== HOOKS ===== */
  /* ===== RENDER ===== */
  return (
    <>
      <UserDashboardPresenter />
    </>
  );
};

export default UserDashboardContainer;
